import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "grid flex flex--wrap flex--justify-space-between flex--align-center" }
const _hoisted_2 = { class: "grid__item a4-12 c6-12 f6-6" }
const _hoisted_3 = { class: "form__set" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "current_password",
  class: "form__label"
}, " Current password ", -1 /* HOISTED */)
const _hoisted_5 = { class: "form__set" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "new_password",
  class: "form__label"
}, " New password ", -1 /* HOISTED */)
const _hoisted_7 = { class: "form__set" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirm_password",
  class: "form__label"
}, " Confirm new password ", -1 /* HOISTED */)
const _hoisted_9 = {
  key: 0,
  class: "form__error"
}
const _hoisted_10 = {
  key: 1,
  class: "form__success"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.submitForm && $options.submitForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            id: "current_password",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.form_fields.current_password) = $event)),
            class: "form__input form__input--stretch",
            type: "password",
            name: "current_password"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $data.form_fields.current_password]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            id: "new_password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.form_fields.new_password) = $event)),
            class: "form__input form__input--stretch",
            type: "password",
            name: "new_password"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $data.form_fields.new_password]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            id: "confirm_password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.form_fields.confirm_password) = $event)),
            class: "form__input form__input--stretch",
            type: "password",
            name: "confirm_password"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $data.form_fields.confirm_password]
          ])
        ]),
        (this.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(this.error), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (this.success)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(this.success), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("button", {
          class: _normalizeClass(["button button--fill mt-32", { 'button--loading' : $data.loading }]),
          type: "submit"
        }, " Save ", 2 /* CLASS */)
      ], 32 /* HYDRATE_EVENTS */)
    ])
  ]))
}